import React from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const products = [
  { id: 1, name: "Apex Hardshell Jacket", price: "$499", rating: "PRO", image: "https://images.unsplash.com/photo-1542223189-67a03fa0f0d8?auto=format&fit=crop&w=600&q=80" },
  { id: 2, name: "Titanium 65L Pack", price: "$289", rating: "EXPEDITION", image: "https://images.unsplash.com/photo-1622560029434-a3f278d655f4?auto=format&fit=crop&w=600&q=80" },
  { id: 3, name: "Granite Approach Boots", price: "$195", rating: "ALL-TERRAIN", image: "https://images.unsplash.com/photo-1520639888713-7851133b1ed0?auto=format&fit=crop&w=600&q=80" },
  { id: 4, name: "Polaris -20°F Bag", price: "$650", rating: "EXTREME", image: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=600&q=80" },
];

const ProductGrid = () => {
  return (
    <section className="py-20 bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-end mb-10">
          <h2 className="text-4xl font-black uppercase tracking-tighter border-l-4 border-orange-600 pl-4">
            Field-Tested Equipment
          </h2>
          <a href="#" className="hidden sm:block text-orange-500 font-bold uppercase tracking-widest text-sm hover:text-orange-400">
            View All Gear [→]
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map(product => (
            <div key={product.id} className="group bg-zinc-950 border border-zinc-800 hover:border-orange-500 transition-colors duration-300 relative">
              <div className="absolute top-4 left-4 z-10 bg-zinc-900 px-2 py-1 text-xs font-bold uppercase tracking-widest border border-zinc-700">
                {product.rating}
              </div>
              <div className="aspect-square bg-zinc-900 relative overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500 mix-blend-luminosity hover:mix-blend-normal"
                />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-lg mb-2 uppercase tracking-wide h-14">{product.name}</h3>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-2xl font-black text-orange-500">{product.price}</span>
                  <button className="bg-zinc-800 hover:bg-orange-600 p-3 transition-colors border border-zinc-700 hover:border-orange-500">
                    <SafeIcon icon={FiShoppingCart} className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;